/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, September 11th 2022, 9:34:17 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TaskTemplate, NextActivation } from "lib/schemas";
import { useWorkflowContext as _useWorkflowContext } from "service-builder/providers";

interface UseSplitNodeHandlersArgs {
  useWorkflowContext: typeof _useWorkflowContext;
}

export const useSplitNodeHandlers = (args: UseSplitNodeHandlersArgs) => {
  const { useWorkflowContext } = args;

  const {
    taskTemplateListContext: { findItem: findTaskTemplate, updateList: updateTaskTempateList },
  } = useWorkflowContext();

  return {
    onSaveActivationBranchCallback: (savedActivation: NextActivation) => {
      if (!savedActivation?.ontrue) return;

      const splitNode = findTaskTemplate(savedActivation.task_definition).item;

      const updatedOutgoingBranches: TaskTemplate["outgoing_branches"] = splitNode.outgoing_branches.map(
        (outgoing_summary) => {
          if (outgoing_summary.activation_settings_id === savedActivation.id) {
            return { activation_settings_id: savedActivation.id, next_id: savedActivation.ontrue };
          }
          return outgoing_summary;
        }
      );

      if (
        !updatedOutgoingBranches.find(
          (outgoing_summary) => outgoing_summary.activation_settings_id === savedActivation.id
        )
      ) {
        updatedOutgoingBranches.push({ activation_settings_id: savedActivation.id, next_id: savedActivation.ontrue });
      }

      const updatedSplitNode: TaskTemplate = {
        ...splitNode,
        outgoing_branches: [...new Set(updatedOutgoingBranches)],
      };

      updateTaskTempateList(updatedSplitNode);
    },

    onDeleteActivationBranchCallback: (deletedActivation: NextActivation) => {
      if (!deletedActivation?.ontrue) return;

      const splitNode = findTaskTemplate(deletedActivation.task_definition).item;

      const updatedSplitNode: TaskTemplate = {
        ...splitNode,
        outgoing_branches: splitNode.outgoing_branches.filter(
          (outgoing_summary) => outgoing_summary.activation_settings_id !== deletedActivation.id
        ),
      };

      updateTaskTempateList(updatedSplitNode);
    },
  };
};
